import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingSpinnerProps {
  minHeight?: number | string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ minHeight = 200 }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight={minHeight}>
      <CircularProgress />
    </Box>
  );
};

export default LoadingSpinner;
